//配置全局访问接口地址
let commonUrl = "https://binanceplan.com/";
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl